import {
  Box, Flex, Text
} from '@huspy/briks-web';
import { useTranslation } from 'react-i18next';
import { Loader } from '@huspy/briks-icons';
import briksTheme from '@shared/briks-theme';
import { headerStyles, headerTextStyles } from './styles.css';

const Badge = ({
  isClientNotLoggedIn,
  isVaultSubmitted,
  isVaultDisabled,
}: {
  isClientNotLoggedIn: boolean;
  isVaultSubmitted: boolean;
  isVaultDisabled: boolean;
}) => {
  const { t } = useTranslation();
  if (isVaultDisabled) {
    return (
      <Box bg='utility-blue-100' borderRadius='5' py='1' px='4'>
        <Text color='utility-blue-800' fontWeight='medium'>
          {t('kyc.header.vaultDisabled')}
        </Text>
      </Box>
    );
  }
  if (!isClientNotLoggedIn && !isVaultSubmitted) {
    return (
      <Flex
        bg='utility-indigo-100'
        borderRadius='5'
        py='1'
        px='4'
        justify='center'
        align='center'
        gap='1'
      >
        <Loader color={ briksTheme.colors['indigo.950'] } />
        <Text color='utility-indigo-950' fontWeight='medium'>
          {t('kyc.header.clientIsFillingData')}
        </Text>
      </Flex>
    );
  }
  if (isClientNotLoggedIn) {
    return (
      <Box bg='utility-blue-100' borderRadius='5' py='1' px='4'>
        <Text color='utility-blue-800' fontWeight='medium'>
          {t('kyc.header.clientNotLogged')}
        </Text>
      </Box>
    );
  }
  return <></>;
};

export const VaultFormHeader = ({
  isClientNotLoggedIn,
  isVaultSubmitted,
  isVaultDisabled,
}: {
  isClientNotLoggedIn: boolean;
  isVaultSubmitted: boolean;
  isVaultDisabled: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      className={ headerStyles }
      justify='space-between'
      align='center'
      bg='blue.50'
      my='3'
    >
      <Flex gap='2' align='center'>
        <Text className={ headerTextStyles } letterSpacing='xl'>
          {t('kyc.header.title1')}
        </Text>
        <Text size='6xl' color='neutral.300'>
          &middot;
        </Text>
        <Text
          className={ headerTextStyles }
          color='neutral.600'
          letterSpacing='xl'
        >
          {t('kyc.header.title2')}
        </Text>
      </Flex>
      <Badge
        isClientNotLoggedIn={ isClientNotLoggedIn }
        isVaultSubmitted={ isVaultSubmitted }
        isVaultDisabled={ isVaultDisabled }
      />
    </Flex>
  );
};
